import { render, staticRenderFns } from "./DocumentosActivosVista.vue?vue&type=template&id=38f1f211&scoped=true"
import script from "./DocumentosActivosVista.vue?vue&type=script&lang=js"
export * from "./DocumentosActivosVista.vue?vue&type=script&lang=js"
import style0 from "./DocumentosActivosVista.vue?vue&type=style&index=0&id=38f1f211&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f1f211",
  null
  
)

export default component.exports